//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from 'vuex';
import Logo from '@/assets/img/primary-logo-blue.svg';
import { FETCH_ALL, LOGOUT } from '@/store/types/actions';
import { AUTH, PERSISTENCE, UI } from '@/store/types/namespaces';
import DpPerf from '../perf/index.ts.vue';
import NavigationBar from './NavigationBar.vue';
import PaymentBanner from './Page/PaymentBanner.ts.vue';
import PrivacyPolicyOverlay from './Page/PrivacyPolicyOverlay.ts.vue';

const INACTIVE_TIMEOUT = 3000;

export default {
  components: {
    DpPerf,
    NavigationBar,
    PaymentBanner,
    PrivacyPolicyOverlay,
  },
  data: () => ({
    resizeSensor: null,
    activityTimerRef: null,
    loadingProgress: 0,
    showUI: false,
    uiActive: true,
    Logo,
  }),
  computed: {
    ...mapState(PERSISTENCE, ['uiDark']),
    ...mapState(UI, ['isFullscreen', 'hasSubnav', 'navigationMinimised']),
    pageClass() {
      return this.$route.meta.section.toLowerCase();
    },
  },
  created() {
    this.loadAppData();

    window.addEventListener('mousemove', this.resetActivityTimer, false);
    window.addEventListener('mousedown', this.resetActivityTimer, false);
    window.addEventListener('keypress', this.resetActivityTimer, false);
    window.addEventListener('DOMMouseScroll', this.resetActivityTimer, false);
    window.addEventListener('mousewheel', this.resetActivityTimer, false);
    window.addEventListener('touchmove', this.resetActivityTimer, false);
    window.addEventListener('MSPointerMove', this.resetActivityTimer, false);

    this.startActivityTimer();
  },
  methods: {
    ...mapActions([FETCH_ALL]),
    ...mapActions(AUTH, [LOGOUT]),
    startActivityTimer() {
      this.activityTimerRef = setTimeout(this.goInactive, INACTIVE_TIMEOUT);
    },
    resetActivityTimer() {
      clearTimeout(this.activityTimerRef);
      this.goActive();
    },
    goInactive() {
      this.uiActive = false;
    },
    goActive() {
      if (!this.uiActive) {
        this.uiActive = true;
      }
      this.startActivityTimer();
    },
    setProgress(percent) {
      this.loadingProgress = percent;
    },
    loadAppData() {
      this.setProgress(0);
      this[FETCH_ALL]({ setProgress: (p) => this.setProgress(p) })
        .then(() => {
          this.setProgress(75);

          // updateUserColoursFromSettings(this.colours);
          this.setProgress(100);

          this.$nextTick(() => {
            this.showUI = true;
          });
        })
        .catch((error) => {
          console.error(error);
          this[LOGOUT](`fail of loadAppData: ${error}`);
        });
    },
  },
};
